import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase, Dialog } from '@material-ui/core';
import QuestionMark from './QuestionMark';
import tokens from '../theme/tokens';

// 회원 전용 안내 — 비회원이 진입 카드를 누르면 열린다. 물음표 아이콘 + 「회원 전용 기능입니다」 + [로그인] [회원가입]
const useStyles = makeStyles((theme) => ({
  paper: {
    width: 400,
    maxWidth: 'calc(100% - 32px)',
    padding: '32px 28px 26px',
    borderRadius: tokens.radiusLg,
    boxShadow: tokens.dialogShadow,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: { padding: '28px 20px 22px' },
  },
  mark: { display: 'block', margin: '0 auto 14px', filter: 'drop-shadow(0 4px 8px rgba(247, 124, 64, 0.28))' },
  title: { fontSize: 20, fontWeight: 700, letterSpacing: -0.9, color: tokens.ink },
  sub: { marginTop: 6, fontSize: 14, letterSpacing: -0.5, color: tokens.muted },
  actions: { display: 'flex', gap: 10, marginTop: 22 },
  btn: {
    flex: 1, height: 46, borderRadius: 23, fontSize: 15, fontWeight: 700, letterSpacing: -0.6,
    transition: 'background-color .12s, border-color .12s, color .12s',
  },
  primary: { backgroundColor: tokens.primary, color: tokens.surface, '&:hover': { backgroundColor: tokens.primaryDark } },
  line: { border: `1px solid ${tokens.line}`, backgroundColor: tokens.surface, color: tokens.text, '&:hover': { borderColor: tokens.primary, color: tokens.primaryDark } },
}));

function VehicleCheckGate({ open, onClose, onLogin, onJoin }) {
  const cs = useStyles();
  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: cs.paper }} aria-labelledby="vehicle-check-gate-title">
      <QuestionMark className={cs.mark} size={64} />
      <div id="vehicle-check-gate-title" className={cs.title}>회원 전용 기능입니다</div>
      <div className={cs.sub}>기업·개인 회원 모두 이용할 수 있어요</div>
      <div className={cs.actions}>
        <ButtonBase className={`${cs.btn} ${cs.primary}`} onClick={onLogin} focusRipple={false}>로그인</ButtonBase>
        <ButtonBase className={`${cs.btn} ${cs.line}`} onClick={onJoin} focusRipple={false}>회원가입</ButtonBase>
      </div>
    </Dialog>
  );
}

export default VehicleCheckGate;
